'use strict';

import Choices from "choices.js";

const Select = {
    els: null,
    init: function () {
        Select.els = document.querySelectorAll('select');
        if (Select.els && Select.els.length > 0) {
            Select.els.forEach(el => {
                new Choices(el, {
                    searchEnabled: el.name === 'country' || el.name === 'category',
                    searchPlaceholderValue: el.name === 'country' ? 'Recherchez un pays...' : 'Recherchez',
                    loadingText: 'Chargement...',
                    itemSelectText: '',
                    noResultsText: 'Aucun résultat',
                    noChoicesText: 'Aucun choix',
                    shouldSort: false
                });
            });
        }

    }
};

export default Select;
